import { FadeIn } from "./FadeIn";
import { MEDIA, STORY } from "@/lib/site";

export const Story = () => {
  return (
    <section
      id="story"
      data-testid="story-section"
      className="relative py-24 sm:py-32 bg-brand-surface"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <FadeIn className="lg:col-span-6 order-2 lg:order-1">
          <div className="relative">
            <div className="aspect-[4/5] rounded-2xl overflow-hidden border border-brand-borderColor">
              <img
                src={MEDIA.orchard}
                alt="Heritage mango orchard at golden hour"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="hidden sm:block absolute -bottom-10 -right-6 w-52 rounded-2xl overflow-hidden border border-brand-borderColor bg-brand-base shadow-sm">
              <img
                src={MEDIA.slice}
                alt="Mango slice"
                className="h-44 w-full object-cover"
              />
              <div className="p-4">
                <div className="text-[10px] uppercase tracking-[0.25em] text-brand-accent font-semibold">
                  Naturally ripened
                </div>
                <div className="font-display text-base text-brand-primary mt-1">
                  Zero chemicals. Ever.
                </div>
              </div>
            </div>
          </div>
        </FadeIn>

        <div className="lg:col-span-6 order-1 lg:order-2">
          <FadeIn>
            <p className="text-xs sm:text-sm uppercase tracking-[0.3em] text-brand-accent font-semibold mb-5">
              {STORY.overline}
            </p>
          </FadeIn>
          <FadeIn delay={0.1}>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-brand-primary leading-[1.05]">
              {STORY.heading}
              <br />
              <span className="italic">{STORY.headingItalic}</span>
            </h2>
          </FadeIn>
          <FadeIn delay={0.2}>
            <div className="mt-8 space-y-5 text-brand-textMuted text-base sm:text-lg leading-relaxed max-w-xl">
              {STORY.paragraphs.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
          </FadeIn>

          <FadeIn delay={0.3}>
            <div className="mt-10 grid grid-cols-2 gap-6 max-w-lg">
              {STORY.points.map((s) => (
                <div
                  key={s.title}
                  className="border-l-2 border-brand-accent pl-4"
                  data-testid={`story-point-${s.title}`}
                >
                  <div className="font-display text-lg text-brand-primary">
                    {s.title}
                  </div>
                  <div className="text-sm text-brand-textMuted mt-1">
                    {s.body}
                  </div>
                </div>
              ))}
            </div>
          </FadeIn>
        </div>
      </div>
    </section>
  );
};

export default Story;
